__turbopack_context__.v({
  "banner-img": "e4896a_banner-img",
  "buttonBox": "e4896a_buttonBox",
  "card-footer-text": "e4896a_card-footer-text",
  "cardContainer": "e4896a_cardContainer",
  "container": "e4896a_container",
  "content": "e4896a_content",
  "darkBG": "e4896a_darkBG",
  "divider": "e4896a_divider",
  "errorMsg": "e4896a_errorMsg",
  "form-group": "e4896a_form-group",
  "illustration": "e4896a_illustration",
  "inputBox": "e4896a_inputBox",
  "intro": "e4896a_intro",
  "large-4": "e4896a_large-4",
  "left": "e4896a_left",
  "lightBG": "e4896a_lightBG",
  "newLetterContainer": "e4896a_newLetterContainer",
  "newsletter-bridge": "e4896a_newsletter-bridge",
  "newsletter-card": "e4896a_newsletter-card",
  "newsletter-columns": "e4896a_newsletter-columns",
  "newsletter-grid": "e4896a_newsletter-grid",
  "newsletter-header": "e4896a_newsletter-header",
  "newsletter-promo": "e4896a_newsletter-promo",
  "newsletter-promo__container": "e4896a_newsletter-promo__container",
  "newsletter-section": "e4896a_newsletter-section",
  "overlay": "e4896a_overlay",
  "right": "e4896a_right",
  "submit-btn": "e4896a_submit-btn",
  "textCenter": "e4896a_textCenter",
});
